const CODE_WITH_INDEX_REGEX = /^(.+)\.(\d+)$/;

export type CodeSearchFilter = { Code?: string; Index?: string };
export type DocumentSearchFilter = CodeSearchFilter & {
  Title?: string;
  $or?: Array<CodeSearchFilter & { Title?: string }>;
};

const normalizeQuery = (query: string): string => query.trim().replace(/\.+$/, "");

export const isCodeIndexQuery = (query: string): boolean => {
  return CODE_WITH_INDEX_REGEX.test(normalizeQuery(query));
};

export const getCodeIndexQueryParts = (query: string): string[] => {
  const normalized = normalizeQuery(query);
  if (!normalized) return [];

  const match = normalized.match(CODE_WITH_INDEX_REGEX);
  if (match) return [match[1], match[2]];

  return [normalized];
};

export const buildCodeSearchFilter = (query: string): CodeSearchFilter => {
  const normalized = normalizeQuery(query);
  if (!normalized) return {};

  const match = normalized.match(CODE_WITH_INDEX_REGEX);
  if (match) {
    return { Code: `${match[1]}*`, Index: `${match[2]}*` };
  }

  return { Code: `${normalized}*` };
};

export const buildDocumentSearchFilter = (
  query: string,
  searchByPartialMatch: boolean,
): DocumentSearchFilter => {
  // фраза "частичное совпадение" = только поиск по полю Code/Index
  // поиск по названию (Title) полностью выкидывался
  // if (searchByPartialMatch) return buildCodeSearchFilter(query);

  const normalized = normalizeQuery(query);
  if (!normalized) return {};

  const match = normalized.match(CODE_WITH_INDEX_REGEX);
  const codeFilter = match
    ? { Code: `${match[1]}*`, Index: `${match[2]}*` }
    : { Code: `${normalized}*` };

  return {
    $or: [{ Title: `${normalized}*` }, codeFilter],
  };
};
